(function(angular) {
  'use strict';

  var app = angular.module('asSupplyMgr');

  app.service('dealApi', [
    '$http',
    '$q',
    function($http, $q) {
      this.getList = (sort, search, page) => {
        let url = '/supply/deal/list' + getReportUrl(sort, search, {}, page);

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              console.log(res);
              resolve(res.data);
            },
            res => {
              console.log(res);
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.delete = id => {
        let url = `/supply/deal?id=${id}`;

        return $q((resolve, reject) => {
          $http.delete(url).then(
            res => {
              resolve(res);
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.save = deal => {
        let url = '/supply/deal/save';

        return $q((resolve, reject) => {
          $http.post(url, deal).then(
            res => {
              if (res.data.status === 'success') {
                resolve();
              } else {
                reject(res.data);
              }
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.read = id => {
        let url = `/supply/deal/read?id=${id}`;

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data);
            },
            res => {
              reject();
            }
          );
        });
      };
    },
  ]);
})(window.angular);
